import axiosInstance from './axiosInstance';

const getToUps = (filters = {}) => {
  const { perPage, page, column, orderColumn, username, status } = filters;

  return axiosInstance.get('/internal/admin/top_up', {
    params: {
      per_page: perPage,
      page,
      column,
      order_column: orderColumn,
      username,
      status,
    },
  });
};

export default getToUps;
